import { createFileRoute } from "@tanstack/react-router";

import { ClientTabPage } from "@/features/booking/modules/client-page/client-tab-page";
import { ClientNutrition } from "@/features/diet-plans/modules/client-nutrition/client-nutrition";
import { DietPlanList } from "@/features/diet-plans/modules/diet-plan-list/diet-plan-list";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/trainees/$clientId/diet")({
  loader: () => ({ crumb: m.client_tab_diet() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { clientId } = Route.useParams();
  return (
    <ClientTabPage clientId={clientId} tab="diet">
      <div className="grid gap-10">
        <DietPlanList clientId={clientId} />
        <ClientNutrition clientId={clientId} />
      </div>
    </ClientTabPage>
  );
}
